import React from 'react';

import { CreateIconComponent } from './CreateIconComponent';

export const EntryIconOutline = CreateIconComponent(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_798_10)">
      <path
        d="M5.125 7.125C4.64175 7.125 4.25 7.51675 4.25 8C4.25 8.48325 4.64175 8.875 5.125 8.875H5.875C6.35825 8.875 6.75 8.48325 6.75 8C6.75 7.51675 6.35825 7.125 5.875 7.125H5.125Z"
        fill="currentColor"
      />
      <path
        d="M7.75 8C7.75 7.51675 8.14175 7.125 8.625 7.125H10.875C11.3582 7.125 11.75 7.51675 11.75 8C11.75 8.48325 11.3582 8.875 10.875 8.875H8.625C8.14175 8.875 7.75 8.48325 7.75 8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5H13C13.2761 2.5 13.5 2.72386 13.5 3V13C13.5 13.2761 13.2761 13.5 13 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V3C2.5 2.72386 2.72386 2.5 3 2.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_798_10">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EntryIconColor = CreateIconComponent(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" role="presentation">
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM3 8C3 7.44772 3.44772 7 4 7H5C5.55228 7 6 7.44772 6 8C6 8.55229 5.55228 9 5 9H4C3.44772 9 3 8.55229 3 8ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55229 7.44772 9 8 9H12C12.5523 9 13 8.55229 13 8C13 7.44772 12.5523 7 12 7H8Z"
        fill="#CD519D"
      />
    </g>
  </svg>
);

export const EntryMacroIcon = CreateIconComponent(
  <svg width="24" height="24" viewBox="0 0 16 16" fill="none" role="presentation">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3ZM7.33398 8C7.33398 7.44772 7.7817 7 8.33398 7H12.334C12.8863 7 13.334 7.44772 13.334 8C13.334 8.55229 12.8863 9 12.334 9H8.33398C7.7817 9 7.33398 8.55229 7.33398 8ZM3.66699 7C3.11471 7 2.66699 7.44772 2.66699 8C2.66699 8.55229 3.11471 9 3.66699 9H5.00033C5.55261 9 6.00033 8.55229 6.00033 8C6.00033 7.44772 5.55261 7 5.00033 7H3.66699Z"
      fill="#CD519D"
    />
  </svg>
);

// Copied from Confluence
export const PageTemplateIcon = CreateIconComponent(
  <svg width="24" height="24" viewBox="0 0 64 64">
    <g>
      <rect width="64" height="64" fill="#2684FF" rx="6" />
      <path
        fill="#FFF"
        d="M42,28.0104 L42,46.0004 L22,46.0004 L22,18.0004 L33.98,18.0004 L33.98,22.9784 C33.98,24.6364 35.322,25.9784 36.98,25.9784 L45.98,25.9784 L45.98,24.9364 C45.98,24.3424 45.716,23.7804 45.262,23.4004 L35.114,14.9284 C34.394,14.3284 33.488,14.0004 32.55,14.0004 L22,14.0004 C19.79,14.0004 18,15.7904 18,18.0004 L18,46.0004 C18,48.2084 19.79,50.0004 22,50.0004 L42,50.0004 C44.21,50.0004 46,48.2084 46,46.0004 L46,28.0104 L42,28.0104 Z M30.0018986,38 C31.0552595,38 31.9182428,38.8088611 31.9945195,39.8497808 L32,40 C32,41.1045695 31.1132936,42 30.0018986,42 L25.9981014,42 C24.8945804,42 24,41.1122704 24,40 C24,38.8954305 24.8867064,38 25.9981014,38 L30.0018986,38 Z M38.0059397,32 C39.0571702,32 39.9184082,32.8088611 39.9945306,33.8497808 L40,34 C40,35.1045695 39.1054862,36 38.0059397,36 L25.9940603,36 C24.8927712,36 24,35.1122704 24,34 C24,32.8954305 24.8945138,32 25.9940603,32 L38.0059397,32 Z"
      />
    </g>
  </svg>
);

export const TrashIcon = CreateIconComponent(
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M19 8l-1.864 11.166a.999.999 0 0 1-.986.834H7.845a1 1 0 0 1-.986-.835L5 8h14zm-2.362 2H7.36l1.332 8h6.611l1.335-8zM5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1H5zm4-.5a.5.5 0 0 1 .491-.5h5.018a.5.5 0 0 1 .491.5V5H9v-.5z"
    />
  </svg>
);

export const NumberIcon = CreateIconComponent(
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M19.5 9.00024C19.5 9.55252 19.0523 10.0002 18.5 10.0002H5.5C4.94772 10.0002 4.5 9.55252 4.5 9.00024C4.5 8.44795 4.94772 8.00024 5.5 8.00024H18.5C19.0523 8.00024 19.5 8.44795 19.5 9.00024Z"
      fill="currentColor"
    />
    <path
      d="M9.65373 4.52926C10.2039 4.57739 10.6109 5.06242 10.5628 5.61261L9.42974 18.5631C9.38161 19.1133 8.89657 19.5203 8.34639 19.4722C7.79621 19.424 7.38922 18.939 7.43735 18.3888L8.57038 5.4383C8.61851 4.88811 9.10354 4.48112 9.65373 4.52926Z"
      fill="currentColor"
    />
    <path
      d="M19.5 15.0002C19.5 15.5525 19.0523 16.0002 18.5 16.0002H5.5C4.94772 16.0002 4.5 15.5525 4.5 15.0002C4.5 14.448 4.94772 14.0002 5.5 14.0002H18.5C19.0523 14.0002 19.5 14.448 19.5 15.0002Z"
      fill="currentColor"
    />
    <path
      d="M15.6537 4.52926C16.2039 4.57739 16.6109 5.06242 16.5628 5.61261L15.4297 18.5631C15.3816 19.1133 14.8966 19.5203 14.3464 19.4722C13.7962 19.424 13.3892 18.939 13.4374 18.3888L14.5704 5.4383C14.6185 4.88811 15.1035 4.48112 15.6537 4.52926Z"
      fill="currentColor"
    />
  </svg>
);

export const HideIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10585 19.2479C4.81296 18.955 4.81296 18.4801 5.10585 18.1872L18.1873 5.10572C18.4802 4.81282 18.9551 4.81282 19.248 5.10572C19.5409 5.39861 19.5409 5.87348 19.248 6.16638L6.16652 19.2479C5.87362 19.5407 5.39875 19.5407 5.10585 19.2479Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8239 9.17613C14.0983 8.44052 13.0904 7.98401 11.9771 7.98401C9.77105 7.98401 7.97705 9.77801 7.97705 11.984C7.97705 13.0969 8.43364 14.1049 9.16936 14.8307L10.5831 13.417C10.2094 13.0534 9.97705 12.5454 9.97705 11.984C9.97705 10.881 10.8741 9.98401 11.9771 9.98401C12.5389 9.98401 13.0468 10.2163 13.4102 10.5898L14.8239 9.17613Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9338 8.4956C16.9022 8.46965 16.8704 8.44383 16.8384 8.41817C15.5549 7.3907 13.8529 6.59999 12.0009 6.59999C7.914 6.59999 4.8009 10.1991 4.8009 12C4.8009 13.1225 6.40241 15.4105 8.81312 16.6163L7.48546 17.9439C7.45334 17.9256 7.42134 17.9071 7.38946 17.8885C4.78128 16.3648 3 13.8266 3 12C3 9.15689 7.032 4.79999 12.0009 4.79999H12C14.4121 4.79999 16.6036 5.82709 18.22 7.20934L16.9338 8.4956ZM9.81356 17.0338C10.4987 17.2644 11.2323 17.4 12 17.4H12.0009C16.0833 17.4 19.1991 13.566 19.1991 12C19.1991 11.2355 18.6266 10.1634 17.6716 9.17576L18.9502 7.89718C20.2307 9.22743 21 10.7581 21 12C21 12.3472 20.9356 12.72 20.8135 13.1068C19.9583 15.8139 16.2706 19.2 12 19.2C11.8475 19.2 11.6956 19.1957 11.5447 19.1872C10.4479 19.1258 9.39594 18.8462 8.42795 18.4194L9.81356 17.0338Z"
      fill="currentColor"
    />
  </svg>
);

export const SortIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="translate(24 24) rotate(-180)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.72328 17.7517C6.72328 18.165 7.17906 18.5 7.74129 18.5C8.30352 18.5 8.7593 18.165 8.7593 17.7517L8.7593 9.27907L10.205 10.7665C10.6357 11.2096 11.3108 11.2442 11.713 10.8436C12.1151 10.443 12.0919 9.75905 11.6612 9.3159L8.54161 6.1063C8.11089 5.66315 7.43575 5.62862 7.03364 6.02919C7.01529 6.04747 6.99783 6.06633 6.98126 6.08573C6.96735 6.09876 6.95367 6.11218 6.94023 6.12601L3.83515 9.3212C3.40642 9.76236 3.38632 10.4462 3.79025 10.8487C4.19417 11.2511 4.86917 11.2197 5.29789 10.7785L6.72328 9.31179L6.72328 17.7517Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2767 6.49824C17.2767 6.08499 16.8209 5.74998 16.2587 5.74998C15.6965 5.74998 15.2407 6.08499 15.2407 6.49824V14.9709L13.795 13.4835C13.3643 13.0403 12.6892 13.0058 12.287 13.4064C11.8849 13.8069 11.9081 14.4909 12.3388 14.9341L15.4584 18.1437C15.8891 18.5868 16.5643 18.6213 16.9664 18.2208C16.9847 18.2025 17.0021 18.1837 17.0187 18.1643C17.0326 18.1512 17.0463 18.1378 17.0598 18.124L20.1649 14.9288C20.5936 14.4876 20.6137 13.8037 20.2097 13.4013C19.8058 12.9989 19.1308 13.0303 18.7021 13.4714L17.2767 14.9382V6.49824Z"
      fill="currentColor"
    />
  </svg>
);

export const CardSwitcherIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M20.5 5H20.506C21.607 5 22.5 5.895 22.5 6.994V19.006C22.4997 19.5348 22.2896 20.0418 21.9157 20.4157C21.5418 20.7896 21.0348 20.9997 20.506 21H8.494C7.96524 20.9997 7.45821 20.7896 7.08432 20.4157C6.71043 20.0418 6.50026 19.5348 6.5 19.006V19H19.5C20.055 19 20.5 18.552 20.5 18V5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 5V7.5H7.5V5H3.5ZM2.5 3C1.94772 3 1.5 3.44772 1.5 4V8.5C1.5 9.05228 1.94772 9.5 2.5 9.5H8.5C9.05228 9.5 9.5 9.05228 9.5 8.5V4C9.5 3.44772 9.05228 3 8.5 3H2.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 12.5V15H7.5V12.5H3.5ZM2.5 10.5C1.94772 10.5 1.5 10.9477 1.5 11.5V16C1.5 16.5523 1.94772 17 2.5 17H8.5C9.05228 17 9.5 16.5523 9.5 16V11.5C9.5 10.9477 9.05228 10.5 8.5 10.5H2.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 5V7.5H16.5V5H12.5ZM11.5 3C10.9477 3 10.5 3.44772 10.5 4V8.5C10.5 9.05228 10.9477 9.5 11.5 9.5H17.5C18.0523 9.5 18.5 9.05228 18.5 8.5V4C18.5 3.44772 18.0523 3 17.5 3H11.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 12.5V15H16.5V12.5H12.5ZM11.5 10.5C10.9477 10.5 10.5 10.9477 10.5 11.5V16C10.5 16.5523 10.9477 17 11.5 17H17.5C18.0523 17 18.5 16.5523 18.5 16V11.5C18.5 10.9477 18.0523 10.5 17.5 10.5H11.5Z"
      fill="currentColor"
    />
  </svg>
);

export const TableSwitcherIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M20.5 5H20.506C21.607 5 22.5 5.895 22.5 6.994V19.006C22.4997 19.5348 22.2896 20.0418 21.9157 20.4157C21.5418 20.7896 21.0348 20.9997 20.506 21H8.494C7.96524 20.9997 7.45821 20.7896 7.08432 20.4157C6.71043 20.0418 6.50026 19.5348 6.5 19.006V19H19.5C20.055 19 20.5 18.552 20.5 18V5Z"
      fill="currentColor"
    />
    <path
      d="M3.2 15.2456H16.7932C16.7856 15.2456 16.7856 6.50437 16.7856 6.50437H3.1932C3.2 6.50437 3.2 15.2456 3.2 15.2456ZM1.5 4.74562C1.5 3.7805 2.2633 3 3.1915 3L16.8085 3C17.7418 3 18.5 3.78312 18.5 4.74475V15.2553C18.4993 15.7172 18.321 16.16 18.004 16.487C17.6871 16.8139 17.2572 16.9984 16.8085 17H3.1915C2.74257 16.9991 2.31234 16.8148 1.99522 16.4877C1.6781 16.1606 1.5 15.7174 1.5 15.2553L1.5 4.74562Z"
      fill="currentColor"
    />
    <path
      d="M6.6 4.75V15.25H8.3V4.75H6.6ZM11.7 4.75V15.25H13.4V4.75H11.7Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2 10H17.65V11.75H3.2V10Z"
      fill="currentColor"
    />
  </svg>
);

export const InfoOutlineIcon = CreateIconComponent(
  <svg width="24" height="24" viewBox="0 0 24 24" role="presentation">
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
        fillRule="nonzero"
      ></path>
      <rect fill="currentColor" x="11" y="10" width="2" height="7" rx="1"></rect>
      <circle fill="currentColor" cx="12" cy="8" r="1"></circle>
    </g>
  </svg>
);

export const HorizontalDragHandlerIcon = CreateIconComponent(
  <svg
    width="21"
    height="15"
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="26"
      height="18"
      rx="5"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <g>
      <path
        d="M11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13C10.5523 13 11 12.5523 11 12Z"
        fill="currentColor"
      />
      <path
        d="M11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9C10.5523 9 11 8.55228 11 8Z"
        fill="currentColor"
      />
      <path
        d="M19 12C19 11.4477 18.5523 11 18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13C18.5523 13 19 12.5523 19 12Z"
        fill="currentColor"
      />
      <path
        d="M19 8C19 7.44772 18.5523 7 18 7C17.4477 7 17 7.44772 17 8C17 8.55228 17.4477 9 18 9C18.5523 9 19 8.55228 19 8Z"
        fill="currentColor"
      />
      <path
        d="M15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13C14.5523 13 15 12.5523 15 12Z"
        fill="currentColor"
      />
      <path
        d="M15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44772 13 8C13 8.55228 13.4477 9 14 9C14.5523 9 15 8.55228 15 8Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const ActiveHorizontalDragHandlerIcon = CreateIconComponent(
  <svg
    width="21"
    height="15"
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="26"
      height="18"
      rx="5"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <rect x="9" y="6" width="2" height="8" rx="1" fill="currentColor" />
    <rect x="13" y="6" width="2" height="8" rx="1" fill="currentColor" />
    <rect x="17" y="6" width="2" height="8" rx="1" fill="currentColor" />
  </svg>
);

export const VerticalDragHandlerIcon = CreateIconComponent(
  <svg
    width="18"
    height="25"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="26"
      rx="5"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z"
      fill="currentColor"
    />
    <path
      d="M12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11Z"
      fill="currentColor"
    />
    <path
      d="M8 19C8.55228 19 9 18.5523 9 18C9 17.4477 8.55228 17 8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19Z"
      fill="currentColor"
    />
    <path
      d="M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
      fill="currentColor"
    />
    <path
      d="M8 15C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15Z"
      fill="currentColor"
    />
    <path
      d="M12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15Z"
      fill="currentColor"
    />
  </svg>
);

export const ActiveVerticalDragHandlerIcon = CreateIconComponent(
  <svg
    width="18"
    height="25"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="26"
      rx="5"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <rect x="6" y="9" width="8" height="2" rx="1" fill="currentColor" />
    <rect x="6" y="13" width="8" height="2" rx="1" fill="currentColor" />
    <rect x="6" y="17" width="8" height="2" rx="1" fill="currentColor" />
  </svg>
);

export const InsertRowAboveIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <rect x="6" y="12" width="12" height="3" rx="0.5" fill="currentColor" />
    <rect x="6" y="16" width="12" height="3" rx="0.5" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 7V5.99C12.9974 5.72652 12.8908 5.47473 12.7036 5.28935C12.5163 5.10397 12.2635 4.99999 12 5C11.444 5 11 5.444 11 5.99V7H10C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8C9 8.26522 9.10536 8.51957 9.29289 8.70711C9.48043 8.89464 9.73478 9 10 9H11V10.01C11.0026 10.2735 11.1092 10.5253 11.2964 10.7107C11.4837 10.896 11.7365 11 12 11C12.556 11 13 10.556 13 10.01V9H14C14.2652 9 14.5196 8.89464 14.7071 8.70711C14.8946 8.51957 15 8.26522 15 8C15 7.73478 14.8946 7.48043 14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7H13Z"
      fill="currentColor"
    />
  </svg>
);

export const InsertRowBelowIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="matrix(-1 0 0 -1 24 24)"
      fill="white"
      fillOpacity="0.01"
    />
    <rect
      x="18"
      y="12"
      width="12"
      height="3"
      rx="0.5"
      transform="rotate(180 18 12)"
      fill="currentColor"
    />
    <rect
      x="18"
      y="8"
      width="12"
      height="3"
      rx="0.5"
      transform="rotate(180 18 8)"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 17V18.01C11.0026 18.2735 11.1092 18.5253 11.2964 18.7107C11.4837 18.896 11.7365 19 12 19C12.556 19 13 18.556 13 18.01V17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16C15 15.7348 14.8946 15.4804 14.7071 15.2929C14.5196 15.1054 14.2652 15 14 15H13V13.99C12.9974 13.7265 12.8908 13.4747 12.7036 13.2893C12.5163 13.104 12.2635 13 12 13C11.444 13 11 13.444 11 13.99V15H10C9.73478 15 9.48043 15.1054 9.29289 15.2929C9.10536 15.4804 9 15.7348 9 16C9 16.2652 9.10536 16.5196 9.29289 16.7071C9.48043 16.8946 9.73478 17 10 17H11Z"
      fill="currentColor"
    />
  </svg>
);
export const InsertColumnBeforeIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="matrix(0 -1 1 0 0 24)"
      fill="white"
      fillOpacity="0.01"
    />
    <rect
      x="12"
      y="18"
      width="12"
      height="3"
      rx="0.5"
      transform="rotate(-90 12 18)"
      fill="currentColor"
    />
    <rect
      x="16"
      y="18"
      width="12"
      height="3"
      rx="0.5"
      transform="rotate(-90 16 18)"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 11H5.99C5.72652 11.0026 5.47473 11.1092 5.28935 11.2964C5.10397 11.4837 4.99999 11.7365 5 12C5 12.556 5.444 13 5.99 13H7V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15C8.26522 15 8.51957 14.8946 8.70711 14.7071C8.89464 14.5196 9 14.2652 9 14V13H10.01C10.2735 12.9974 10.5253 12.8908 10.7107 12.7036C10.896 12.5163 11 12.2635 11 12C11 11.444 10.556 11 10.01 11H9V10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9C7.73478 9 7.48043 9.10536 7.29289 9.29289C7.10536 9.48043 7 9.73478 7 10V11Z"
      fill="currentColor"
    />
  </svg>
);

export const InsertColumnAfterIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="translate(0 24) rotate(-90)"
      fill="white"
      fillOpacity="0.01"
    />
    <rect
      x="9"
      y="18"
      width="12"
      height="3"
      rx="0.5"
      transform="rotate(-90 9 18)"
      fill="currentColor"
    />
    <rect
      x="5"
      y="18"
      width="12"
      height="3"
      rx="0.5"
      transform="rotate(-90 5 18)"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 11L13.99 11C13.7265 11.0026 13.4747 11.1092 13.2893 11.2964C13.104 11.4837 13 11.7365 13 12C13 12.556 13.444 13 13.99 13L15 13L15 14C15 14.2652 15.1054 14.5196 15.2929 14.7071C15.4804 14.8946 15.7348 15 16 15C16.2652 15 16.5196 14.8946 16.7071 14.7071C16.8946 14.5196 17 14.2652 17 14L17 13L18.01 13C18.2735 12.9974 18.5253 12.8908 18.7107 12.7036C18.896 12.5163 19 12.2635 19 12C19 11.444 18.556 11 18.01 11L17 11L17 10C17 9.73478 16.8946 9.48043 16.7071 9.29289C16.5196 9.10536 16.2652 9 16 9C15.7348 9 15.4804 9.10536 15.2929 9.29289C15.1054 9.48043 15 9.73478 15 10L15 11Z"
      fill="currentColor"
    />
  </svg>
);
export const ExpandIcon = CreateIconComponent(
  <svg width="24" height="24" viewBox="0 0 24 24" role="presentation">
    <path
      transform="rotate(-45 12 12)"
      d="M18.062 11L16.5 9.914A1 1 0 1117.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 01-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1h3.68zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 017.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 016.086 15.5L3.47 12.884z"
      fill="currentColor"
    ></path>
  </svg>
);

export const CollapseIcon = CreateIconComponent(
  <svg width="24" height="24" viewBox="0 0 24 24" role="presentation">
    <path
      transform="rotate(-45 12 12)"
      d="M8.062 11L6.5 9.914A1 1 0 017.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 116.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1h3.68zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0117.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 01-1.414 1.414l-2.616-2.616z"
      fill="currentColor"
    ></path>
  </svg>
);

export const SummationIcon = CreateIconComponent(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 20V18.5328L12.3415 12.0511V11.9489L7 5.46721V4H17.1818V5.47649H9.24364V5.56007L14.5623 11.9489V12.0511L9.24364 18.4399V18.5235H17.1818V20H7Z"
      fill="#172B4D"
    />
  </svg>
);
